import { useRouter } from 'vue-router'
import { computed, watchEffect, ComputedRef } from 'vue'

export const usePaginationUrlQuery = (): {
    updateUrlQuery: (page: string) => void
    currentPage: ComputedRef<number>
} => {
    const router = useRouter()
    const { currentRoute } = router

    const updateUrlQuery = (page: string) => {
        router.push({
            query: {
                ...currentRoute.value.query,
                page,
            },
        })
    }

    watchEffect(() => {
        const pageFromUrl = Number(currentRoute.value.query?.page)
        if (currentRoute.value.query?.page && (pageFromUrl <= 0 || !pageFromUrl)) {
            updateUrlQuery(String(1))
        }
    })

    return {
        updateUrlQuery,
        currentPage: computed(() => Number(currentRoute.value.query?.page) || 1),
    }
}
